const environment = {
  api:
    process.env.REACT_APP_API_URL ||
    process.env.REACT_APP_API ||
    process.env.API ||
    'https://kindaapi.jcsoftwaresolution.in/',
  googleAPIKey:
    process.env.REACT_APP_GOOGLE_API_KEY ||
    'AIzaSyDhsAnr0k0oWjWn48iqiW4XUX4dvWzvtMA',
  chat_api:
    process.env.REACT_APP_CHAT_API_URL ||
    process.env.REACT_APP_CHAT_API ||
    'https://kindachat.jcsoftwaresolution.in/',
  appId:
    process.env.REACT_APP_AGORA_APP_ID ||
    process.env.REACT_APP_APP_ID ||
    'd3e3e518e5cb40a4a8bef438814eee16',
  customerId:
    process.env.REACT_APP_AGORA_CUSTOMER_ID ||
    process.env.REACT_APP_CUSTOMER_ID ||
    'ec7b8b06ffc54f84961a3cf9a8e0d7fc',
  customerSecret:
    process.env.REACT_APP_AGORA_CUSTOMER_SECRET ||
    process.env.REACT_APP_CUSTOMER_SECRET ||
    'f7b71c4330044672b86e43bf2bd14ac2',
  map_api_key:
    process.env.REACT_APP_MAP_API_KEY ||
    process.env.MAP_API_KEY ||
    '',
  userRoleId:
    process.env.REACT_APP_USER_ROLE_ID ||
    process.env.USER_ROLE_ID ||
    'user',
  adminRoleId:
    process.env.REACT_APP_ADMIN_ROLE_ID ||
    process.env.ADMIN_ROLE_ID ||
    'admin',
  encryptionSecret:
    process.env.REACT_APP_ENCRYPTION_SECRET ||
    process.env.VITE_ENCRYPTION_SECRET ||
    '682e36bcd5fb57ace4ea85cf027fb01b8a2e2f32782a9efb4ab7c3cbdf47fd13',
};

export default environment;